import React from 'react';
import type { usePrompt } from '../../utils/primeX.util';

export const FirmoFormContext = React.createContext({
  isEditable: true,
  isMlChildSubmission: false,
  promptState: {
    determineIsViewDirty: (_name: string, _isDirty: boolean) => {
      //
    },
  },
});

interface FirmoFormProviderProps {
  children: React.ReactNode;
  isEditable: boolean;
  promptState?: ReturnType<typeof usePrompt>;
  isMlChildSubmission: boolean;
}

export const FirmoFormProvider = ({
  children,
  isEditable,
  promptState,
  isMlChildSubmission,
}: FirmoFormProviderProps) => {
  return (
    <FirmoFormContext.Provider
      value={{
        isEditable,
        promptState: promptState as unknown as ReturnType<typeof usePrompt>,
        isMlChildSubmission,
      }}
    >
      {children}
    </FirmoFormContext.Provider>
  );
};

export const useFirmoFormContext = () => {
  const context = React.useContext(FirmoFormContext);

  return context;
};
